// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import * as tslib_1 from "tslib";
import { DataPoint as AIDataPoint } from '../../Interfaces/Contracts/Generated/DataPoint';
import { FieldType } from '../../Enums';
var DataPoint = /** @class */ (function (_super) {
    tslib_1.__extends(DataPoint, _super);
    function DataPoint() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * The data contract for serializing this object.
         */
        _this.aiDataContract = {
            name: FieldType.Required,
            kind: FieldType.Default,
            value: FieldType.Required,
            count: FieldType.Default,
            min: FieldType.Default,
            max: FieldType.Default,
            stdDev: FieldType.Default
        };
        return _this;
    }
    return DataPoint;
}(AIDataPoint));
export { DataPoint };
//# sourceMappingURL=DataPoint.js.map